export const ALLOWED_FILE_TYPES = [{ name: 'CSV', type: 'text/csv' }]
